/**
 * Created by t.baldauf on 09.11.2016.
 */
$(document).scroll(function() {
    var y = $(this).scrollTop();
    if (y > 800) {
        $('.up-button').fadeIn();
    } else {
        $('.up-button').fadeOut();
    }
});
$(document).ready(function(){
    $(".up-button a").unbind("click");
    $(".up-button a").on("click", function(e){
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0}, 'slow');
    });
});